export const APP_TICK_TIMER_MS = 5 * 60 * 1000; //every 5 minutes
export const SESSION_REFRESH_THRESHOLD_MS = 3 * APP_TICK_TIMER_MS; //15 minutes before expiration
export const AVERAGE_AUTH_RESPONSE_TIME = 100;

export const METRICS_DATA_SETS_START_TIME = '2018-07-01T00:00:00.000Z';
export const METRICS_DATA_SETS_START_TIME_LABEL = 'Since July 1, 2018 00:00am UTC';

export const TABLE_NEST_INDENT_PX = 12;
